import React, { useCallback } from 'react';

function SDGItem({ number, label, color, delay }) {
  const handleMouseMove = useCallback((e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    const transform = `translateY(-10px) scale(1.08) perspective(400px) rotateY(${x * 10}deg) rotateX(${-y * 10}deg)`;
    e.currentTarget.style.transform = transform;
  }, []);

  const handleMouseLeave = useCallback((e) => {
    e.currentTarget.style.transform = '';
  }, []);

  return (
    <div
      className={`sdg-item reveal reveal-${delay}`}
      style={{ background: color }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <span className="sdg-number">{number}</span>
      <span className="sdg-label">{label}</span>
    </div>
  );
}

export default SDGItem;
